import customProductCard from "../components/custom-product-card";

const SRPListener = (function () {

    return {
        init: async function () {
            console.log("SRPListener initialized");
            customProductCard.init({
                containerSelector: ".boost-pfs-filter-products",
                notifyMeConfig: {
                    enabled: true,
                    triggerSelector: '.BIS_trigger.notify_me-btn'
                }
            });
        }
    };
})();

export default SRPListener;
